import $ from 'jquery'
import Swiper, { FreeMode } from 'swiper'
import { isMobileBreakpoint } from './helpers'
const bodyScrollLock = require('body-scroll-lock')
const disableBodyScroll = bodyScrollLock.disableBodyScroll
const enableBodyScroll = bodyScrollLock.enableBodyScroll

/*
  Carousel 
*/

new Swiper('.mySwiper', {
  spaceBetween: 0,
  slidesPerView: 1.5,
  freeMode: true,
  modules: [FreeMode],
  breakpoints: {
    800: {
      slidesPerView: 2.75,
    },
    960: {
      slidesPerView: 3.75,
    },
  },
})

/*
  Open / Close case study modals
*/

let active

$('.case-studies-slide').on('click', function () {
  const modalSelector = $(this).attr('data-modal')
  $(modalSelector).addClass('case-studies-modal--active')
  active = document.querySelector('.case-studies-modal--active')
  disableBodyScroll(active)
})

$('.case-studies-modal-close-button').on('click', function () {
  closeCaseStudy()
})

export function closeCaseStudy() {
  $('.case-studies-modal').removeClass('case-studies-modal--active')
  enableBodyScroll(active)
}

/*
  Convert vert scroll to horizontal on desktop
*/

window.addEventListener('wheel', function (e) {
  if (!isMobileBreakpoint()) {
    const activeSlide = document.querySelector('.case-studies-modal--active')

    if (activeSlide) {
      const activeSlideContent = activeSlide.querySelector('.case-studies-modal-content')

      if (activeSlide && e.deltaX === 0) {
        e.preventDefault()

        const activeSlideContent = activeSlide.querySelector('.case-studies-modal-content')
        activeSlideContent.scrollLeft += e.deltaY * 1.5
      }
    }
  }
})
